function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.9004,
  cy: 20.962,
  r: 20.75,
  fill: "#A66FFE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.173 13.3898C21.448 13.3898 22.4525 12.3853 22.4525 11.1104C22.4525 9.83544 21.448 8.83093 20.173 8.83093C18.8981 8.83093 17.8936 9.83544 17.8936 11.1104C17.8936 12.3853 18.8981 13.3898 20.173 13.3898ZM20.173 9.60363C21.023 9.60363 21.6798 10.2604 21.6798 11.1104C21.6798 11.9603 21.023 12.6171 20.173 12.6171C19.323 12.6171 18.6663 11.9603 18.6663 11.1104C18.6663 10.2604 19.323 9.60363 20.173 9.60363Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6773 27.8007L26.432 21.3874L26.2775 21.001C26.2389 20.8465 26.0843 20.7306 25.9298 20.7306H22.2595V19.8033H25.0798C25.3116 19.8033 25.4662 19.6488 25.4662 19.417V16.8671C25.4662 16.6353 25.3116 16.4807 25.0798 16.4807H22.2595V14.7422C22.2595 14.5104 22.1049 14.3558 21.8731 14.3558H18.4733C18.2415 14.3558 18.0869 14.5104 18.0869 14.7422V23.6668C18.0869 23.8986 18.2415 24.0532 18.4733 24.0532H23.6117L26.3161 29.462C26.3934 29.6166 26.5093 29.6938 26.6638 29.6938C26.7025 29.6938 26.7797 29.6938 26.8184 29.6552L29.4842 28.3416C29.5614 28.303 29.6387 28.2257 29.6773 28.1098C29.716 27.9939 29.716 27.878 29.6773 27.8007ZM26.857 28.7666L24.1912 23.4736C24.1139 23.3577 23.998 23.2418 23.8435 23.2418H18.8596V15.0899H21.4868V16.8285C21.4868 17.0603 21.6413 17.2148 21.8731 17.2148H24.6935V18.992H21.8731C21.6413 18.992 21.4868 19.1465 21.4868 19.3784V21.0783C21.4868 21.3101 21.6413 21.4646 21.8731 21.4646H25.6593L25.7366 21.6192V21.6578L28.8274 27.7621L26.857 28.7666Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3025 28.4574C21.9889 29.771 20.289 30.4664 18.4731 30.4664C14.6869 30.4664 11.6348 27.4142 11.6348 23.628C11.6348 20.6145 13.6438 17.9487 16.5028 17.0988C16.6959 17.0215 16.8118 16.8283 16.7732 16.6351C16.6959 16.442 16.5028 16.3261 16.3096 16.3647C13.1029 17.3306 10.9007 20.3054 10.9007 23.6667C10.8621 27.8392 14.2619 31.2391 18.4731 31.2391C20.4821 31.2391 22.4139 30.4278 23.8434 28.9983C23.9979 28.8437 23.9979 28.6119 23.8434 28.4574C23.6888 28.3028 23.457 28.3028 23.3025 28.4574Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.8082,
  cy: 8.96505,
  r: 6.97126,
  fill: "white",
  stroke: "#A66FFE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8081 9.29601L34.7854 2.22556L38.9775 5.59372L32.8081 9.29601Z",
  fill: "#A66FFE"
});

var SvgStd = function SvgStd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/std.342ce4ae.svg";
export { ForwardRef as ReactComponent };